import isAncestor from './isAncestor'

function renderSortedPlaylistData(data) {
  const playlists = data.filter((temp) => temp.id.slice(0, 1) === 'p')
  const items = []
  playlists.forEach((playlist) => {
    const sortedPlaylistItems = []
    const playlistItems = data.filter((check) =>
      isAncestor(data, playlist.id, check.id),
    )

    sortedPlaylistItems.push(
      ...playlistItems.filter((check) => check.parent === playlist.id),
    )

    renderFolders(sortedPlaylistItems, data, playlistItems.length)
    items.push(...sortedPlaylistItems)
  })
  return items
}

function renderFolders(items, data, totalItems) {
  const filled = {}
  let i = 0
  while (items.length !== totalItems) {
    const iterator = [...items]
    iterator.forEach((item) => {
      if (item.id.slice(0, 1) === 'g' && !filled[item.id]) {
        const children = data.filter((check) => check.parent === item.id)
        const index = items.findIndex((check) => check.id === item.id) + 1
        items.splice(index, 0, ...children)
        filled[item.id] = true
      }
    })
    if (i++ > 10) {
      console.error('max depth reached')
      break
    }
  }
}

export default renderSortedPlaylistData
